export const RouterName = {
  login: '/login',
  recover: '/recover',
  dashboard: '/dashboard',
  help: '/help',
  create: '/create',
  manage: '/manage',
  account: '/account',
  emergencyContact: '/emergency-contact',
  documentDetails: (id: string) => `/manage/documents/${id}`,
};
